var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnallocatedTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6907 9.252C10.9773 8.8736 11.1538 8.40775 11.1538 7.89744V7.69231H13.8205V6.46154H11.1538V6.25641C11.1538 5.01202 10.1418 4 8.89744 4H7.25641C6.01202 4 5 5.01202 5 6.25641V7.89744C5 9.14183 6.01202 10.1538 7.25641 10.1538H8.89744C9.1842 10.1538 9.45623 10.0948 9.70878 9.99684L13.0033 13.9504C13.2759 13.6394 13.6036 13.3836 13.9748 13.1931L10.6907 9.252ZM9.92308 7.89744C9.92308 8.46314 9.46314 8.92308 8.89744 8.92308H7.25641C6.69071 8.92308 6.23077 8.46314 6.23077 7.89744V6.25641C6.23077 5.69071 6.69071 5.23077 7.25641 5.23077H8.89744C9.46314 5.23077 9.92308 5.69071 9.92308 6.25641V7.89744Z",
    fill: "#172B4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 4.6,
    width: 4.8,
    height: 4.8,
    rx: 1.4,
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 14.6,
    width: 4.8,
    height: 4.8,
    rx: 1.4,
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnallocatedTicketIc);
export default __webpack_public_path__ + "static/media/unallocated_ticket_ic.7ee51f585d17ac6714f31bec32d254aa.svg";
export { ForwardRef as ReactComponent };